export default __webpack_public_path__ + "static/media/frame_corner_bottom_left.fe0b986b.png";